import { useState, useEffect } from 'react'

export interface ContactSubmission {
  id: string
  name: string
  email: string
  phone: string
  date: string
}

const STORAGE_KEY = 'bvb_contact_submissions'

export function useContactSubmissions() {
  const [submissions, setSubmissions] = useState<ContactSubmission[]>([])

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try {
        setSubmissions(JSON.parse(stored))
      } catch (e) {
        console.error('Failed to parse contact submissions', e)
      }
    }
  }, [])

  const addSubmission = (data: Omit<ContactSubmission, 'id' | 'date'>) => {
    const newEntry: ContactSubmission = {
      ...data,
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
    }
    const updated = [...submissions, newEntry]
    setSubmissions(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  const deleteSubmission = (id: string) => {
    const updated = submissions.filter((s) => s.id !== id)
    setSubmissions(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  return { submissions, addSubmission, deleteSubmission }
}

// Standalone save function for use outside of hook context
export function saveContactSubmission(
  data: Omit<ContactSubmission, 'id' | 'date'>,
) {
  const stored = localStorage.getItem(STORAGE_KEY)
  const existing: ContactSubmission[] = stored ? JSON.parse(stored) : []
  const newEntry: ContactSubmission = {
    ...data,
    id: crypto.randomUUID(),
    date: new Date().toISOString(),
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...existing, newEntry]))
}
